
import Vue from 'vue';

export default Vue.extend({
    props: {
        text: {
            type: String,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false
        },
        correct: {
            type: Boolean,
            default: false
        },
        percentage: {
            type: Number,
            default: 100
        }
    },

    computed: {
        percent(): number {
            return Math.max(Math.min(100, this.percentage as number), 0);
        },
        percentageText():string {
            return this.percent.toFixed(2) + '%';
        }
    }
});
